import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FaBell, FaBellSlash } from 'react-icons/fa'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault/index'
import './styles.scss'
const baseClass = 'push-subscribe-button'

class PushSubscribeButton extends Component {
  static propTypes = {
    isPushEnabled: PropTypes.bool,
    isOptedOut: PropTypes.bool,
    onGetSubscriptionState: PropTypes.func.isRequired,
    onSubscribePush: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    isNotificationsBlocked: PropTypes.bool,
  }

  componentDidMount() {
    this.props.onGetSubscriptionState()
  }

  render() {
    const { t, isPushEnabled, isOptedOut, onSubscribePush, isPending, isNotificationsBlocked } = this.props

    if (isPushEnabled === false) {
      return (
        <Button
          sm
          outline
          className={`${baseClass}__button`}
          onClick={() => onSubscribePush()}
          submitting={isPending}
          disabled={isPending || isNotificationsBlocked}
        >
          <FaBell className={`${baseClass}__icon`} />
          {t('Enable desktop notifications')}
        </Button>
      )
    }

    if (isOptedOut === false) {
      return (
        <Button
          sm
          remove
          onClick={() => onSubscribePush()}
          submitting={isPending}
          disabled={isPending || isNotificationsBlocked}
        >
          <FaBellSlash className={`${baseClass}__icon`} />
          {t('Disable desktop notifications')}
        </Button>
      )
    }
    return null
  }
}

export default withTranslation('user')(PushSubscribeButton)
